import ApplicationAdapter from './application';

export default class GlobalFlowAdapter extends ApplicationAdapter {
  urlForUpdateRecord(id, modelName, snapshot) {
    return this.buildURL(modelName, id, snapshot, 'v3') + '?include=flows.location';
  }
}
